import { Routes } from "@angular/router";
import { PageNotFoundComponent } from "./shared/components/page-not-found/page-not-found.component";
import { AuthLayoutComponent } from "./core/auth/auth-layout/auth-layout.component";
import { FormComponent } from "./core/auth/form/form.component";
import { CreateNewPasswordComponent } from "./core/auth/create-new-password/create-new-password.component";
import { ForgotPasswordRequestComponent } from "./core/auth/forgot-password-request/forgot-password-request.component";
import { notLoggedInGuard } from "./core/auth/not-logged-in.guard";
import { AuthGuard } from "./core/auth/auth.guard";
import { NotAuthorizedComponent } from "./core/pages/not-authorized/not-authorized.component";
import { ConfirmEmailChangeComponent } from "./core/auth/confirm-email-change/confirm-email-change";
import { VerifyEmailSentComponent } from "./core/auth/verify-email-sent/verify-email-sent";
import { ConfirmEmailComponent } from "./core/auth/confirm-email/confirm-email";
import { SinglePostResolver } from "./features/user/features/post/single-post.resolver";

export const routes: Routes = [
  // PUBLIC ROUTES
  // {
  //   path: "posts/:id",
  //   loadComponent: () =>
  //     import("src/app/shared/components/single-post/single-post.component")
  //       .then(m => m.SinglePostComponent),
  //   resolve: {
  //     post: SinglePostResolver,
  //   },
  // },

  {
    path: "login",
    canActivate: [notLoggedInGuard],
    component: AuthLayoutComponent,
    children: [
      {
        path: "glomtLosenord",
        component: ForgotPasswordRequestComponent,
      },
      {
        path: "nyttLosenord",
        component: CreateNewPasswordComponent,
      },
      {
        path: "confirm-email",
        component: ConfirmEmailComponent,
      },
      {
        path: "verify-email-sent",
        component: VerifyEmailSentComponent,
      },
      {
        path: "confirm-email-change",
        component: ConfirmEmailChangeComponent,
      },
      {
        path: "",
        component: FormComponent,
      },
    ],
  },

  {
    path: "not-authorized",
    component: NotAuthorizedComponent,
  },
  // PROTECTED APP
  {
    path: "",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("src/app/core/layout/main-view.routes").then((m) => m.routes),
  },
  {
    path: "**",
    redirectTo: "not-found",
  },


];
